import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Pricing from "./components/Pricing";
import Stats from "./components/Stats";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ServiceDetail from "./components/ServiceDetail";
import BlogPage from "./components/BlogPage";
import BlogDetail from "./components/BlogDetail";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";
import Checkout from "./components/Checkout";
import PaymentSuccess from "./components/PaymentSuccess";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";

const HomePage = () => {
  return (
    <>
      <div id="hero">
        <Hero />
      </div>
      <Services />
      <div id="about">
        <About />
      </div>
      <Testimonials />
      <div id="pricing">
        <Pricing />
      </div>
      <Stats />
      <div id="blog">
        <Blog />
      </div>
      <Contact />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/service/:serviceId" element={<ServiceDetail />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:blogSlug" element={<BlogDetail />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
      </Routes>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;